import {ModalCopy_CurrentStep, ModalCopy_Type} from "../@const"
import Workspace from "../../../model2/space/workspaces/workspace"
import ProjectSession from "../../../model2/project/project-session"
import Modal_getMissingUsersTeams, {ModalMoveTo_MissingUsersTeams} from "../../move-to/actions/get-missing-users-and-teams"
import {MissingUsersTeamsManagerInterface} from "../../components/add-missing-users-and-teams/missing-users-teams-manager-interface"

// const debug = "Copy_Manager"
const debug = false

export class Copy_Manager implements MissingUsersTeamsManagerInterface {

    public type                 : ModalCopy_Type

    public targetWorkspace?     : Workspace         // workspace we add to
    public targetProject?       : ProjectSession    // project we add to
    public missingUsersTeams?   : ModalMoveTo_MissingUsersTeams

    public currentStep          : ModalCopy_CurrentStep = ModalCopy_CurrentStep.LOADING

    public onCopy?              : func              // callback on copy is commited

    public reRender             : callback          // rerender modal callback

    protected result            : any               // stores modal form result while users are validated

    constructor(type: ModalCopy_Type) {
        this.type       = type

        this.reRender   = () => {
            console.warn('Copy_Manager: reRender is not implemented')
        }
    }

    init = async () => {
        /*should be overridden*/
    }

    async validateUsers(result: any) {
        this.result = result

        debug && console.log(debug, 'validateUsers', result, this)
        this.setCurrentStep(ModalCopy_CurrentStep.CHECKING_USERS)

        this.targetProject      = gd.session.projects.get(result.parentProject) || undefined
        this.targetWorkspace    = this.targetProject?.workspace || undefined

        this.missingUsersTeams = await Modal_getMissingUsersTeams(this)
        const clearedUsers = _.omitBy(this.missingUsersTeams, _.isEmpty)

        debug && console.log(debug, 'validateUsers', this.missingUsersTeams, clearedUsers)

        if (_.isEmpty(clearedUsers)) {
            this.setCurrentStep(ModalCopy_CurrentStep.COPYING)
            this.commitCopy(this.result)
        } else {
            this.onAddMissingUsers()
        }
    }

    async commitCopy(result?: any) {
        /*should be overridden*/
    }

    get modalTitle():string {
        /*should be overridden*/
        return ''
    }

    get showProjectAccess() {
        return false
    }

    get affectedTasksIds(): ID[] {
        return []
    }

    get affectedProjectIds(): ID[] {
        return[]
    }

    commit() {
        this.commitCopy()
    }

    onAddMissingUsers() {
        this.setCurrentStep(ModalCopy_CurrentStep.ADD_MISSING_USERS)
    }

    setCurrentStep = (step: ModalCopy_CurrentStep) => {
        this.currentStep = step
        this.reRender()
    }
}
